export enum ResponseErrorDataType {
    NotSet = 0,
    Error = 1,
    ValidationError = 2,
    NotFoundError = 3,
    Forbidden = 4,
    Expired = 5,
}
